import { render, staticRenderFns } from "./bank-statements-detail.vue?vue&type=template&id=40345225&"
import script from "./bank-statements-detail.vue?vue&type=script&lang=js&"
export * from "./bank-statements-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports